import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { IconTile } from '@/components/IconTile';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconLoan from '@/assets/icons/heroIcons/Loan.svg';
import IconDatabase from '@/assets/icons/heroIcons/Database.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconGlobe from '@/assets/icons/heroIcons/Globe.svg';
import { Button } from '@/components/buttons';
import AppIntro from '@/sections/AppIntro';
import { useProductRegistrationLink } from '@/hooks/useProductRegistrationLink';
function About() {
  const $ = _c(49);
  const {
    t
  } = useTranslation("card");
  const registrationLink = useProductRegistrationLink("karta");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bgCircle absolute top-28 right-0 h-44 w-44 translate-x-[70%] rotate-90 lg:h-125 lg:w-125 lg:translate-x-1/4 lg:rotate-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("aboutSection.benefits.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mx-auto mb-10 max-w-192 px-0 lg:mb-16" anchorKey="aboutSection.benefits.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("aboutSection.benefits.benefit.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconTile icon={<IconLoan />} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = {
      title: t3,
      icon: t4
    };
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("aboutSection.benefits.benefit.2.title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconTile icon={<IconDatabase />} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = {
      title: t6,
      icon: t7
    };
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("aboutSection.benefits.benefit.5.title");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconTile icon={<IconGlobe />} />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t9) {
    t11 = {
      title: t9,
      icon: t10
    };
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("aboutSection.benefits.benefit.6.title");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconTile icon={<IconCard />} />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = {
      title: t12,
      icon: t13
    };
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14 || $[27] !== t5 || $[28] !== t8) {
    t15 = <BenefitTiles background="bg-blue-50" classNameItem="max-w-[27.5rem]" items={[t5, t8, t11, t14]} />;
    $[25] = t11;
    $[26] = t14;
    $[27] = t5;
    $[28] = t8;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("aboutSection.benefits.button");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== registrationLink || $[33] !== t16) {
    t17 = <Button variant="primary" align="center" size="lg" to={registrationLink} testId="cardAboutSectionBenefits" analyticsParam="cardAboutSectionBenefits" className="mt-12 mb-14 lg:mt-16 lg:mb-20">{t16}</Button>;
    $[32] = registrationLink;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17 || $[37] !== t2) {
    t18 = <div className="px-4">{t2}{t15}{t17}</div>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t2;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t) {
    t19 = t("aboutSection.mobapp.title");
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("aboutSection.mobapp.cta");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19 || $[44] !== t20) {
    t21 = <AppIntro title={t19} anchorKey="aboutSection.mobapp.title" cta={t20} video="/videos/cs/app-card.mp4" className="py-14 lg:pt-20 lg:pb-20" />;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t18 || $[47] !== t21) {
    t22 = <div className="relative z-30 overflow-hidden bg-blue-100 pt-14 lg:pt-20">{t0}{t18}{t21}</div>;
    $[46] = t18;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  return t22;
}
export default About;